import { IHttpPromise, IHttpResponse, IQService, IHttpService } from 'angular';
import { ResponseErrorData } from '../models/rest.model';
import ErrorService from './error/error.service';

/* @ngInject */
export default class HttpService {
  private static getResponseError(
    response: IHttpResponse<any>
  ): ResponseErrorData {
    const responseData = response.data;
    if (angular.isObject(responseData)) {
      const responseError = responseData.error;
      if (angular.isObject(responseError)) {
        return responseError;
      }
    }

    const errorMessage = response.headers('HafifMuzikError');
    if (errorMessage) {
      const errorDetails = errorMessage.split(':', 2);
      return new ResponseErrorData(
        parseInt(errorDetails[0], 10),
        errorDetails[1],
        errorMessage
      );
    }
    return null;
  }

  constructor(
    private $q: IQService, 
    private errorService: ErrorService,
    private $http: IHttpService
  ) {}
  public promiseCache = {};	

  public extractResponseData(
    promise: IHttpPromise<any>,
    showErrorNotification = true,
    isPayment = false
  ) {
    return promise.then(response => {
      if (angular.isObject(response)) {
        const responseError = HttpService.getResponseError(response);
        if (showErrorNotification && responseError) {
          this.errorService.onResponseError(responseError, isPayment);
          return this.$q.reject(responseError);
        }
        return response.data;
      }
      return response;
    }).catch(error => {
      if (angular.isObject(error)) {
        if(showErrorNotification && !!error && !!error.data && !!error.data.error){
          this.errorService.onResponseError(error.data.error, isPayment);
          return this.$q.reject(error.data.error);
        } else{
          const responseError = HttpService.getResponseError(error);
          if (showErrorNotification && responseError) {
            this.errorService.onResponseError(responseError, isPayment);
            return this.$q.reject(responseError);
          }
        }
      }
    });
  }

  public extractResponseResult(
    promise: IHttpPromise<any>,
    showErrorNotification = true,
    isPayment = false
  ) {
    return this.extractResponseData(
      promise,
      showErrorNotification,
      isPayment
    ).then((responseData: any) => {
      return angular.isObject(responseData)
        ? responseData.result
        : responseData;
    });
  }

  public getResultFromCache(
    key: string,
    url: string
  ){
    var cacheValue = this.promiseCache[key];
    if (!cacheValue || Math.floor(Math.random() * 10)==9) {
      cacheValue =  this.extractResponseResult(this.$http.get(url, null));
      this.promiseCache[key] = cacheValue;
    } 
    return cacheValue;
  }

  public evictResultCache(
    key:string,
    removeStartsWith: boolean= false
  ){
    var cacheValue = this.promiseCache[key];
    if (!!cacheValue) {
      this.promiseCache[key] = null;
    } else if(removeStartsWith){
      for(var cacheKey in this.promiseCache){
        if(cacheKey.startsWith(key)){
          this.promiseCache[cacheKey] = null;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/http.service.ts